export function usePropBasedStyles(StylesObj: any) {
  return function usePropBasedStyles(props: any) {
    return (() => {
      const cls = []
      for (let _flag in props) {
        const flag = _flag as keyof typeof props
        if (typeof props[flag] === 'boolean' && props[flag])
          cls.push(StylesObj[flag])
      }
      return cls.join(' ')
    })()
  }
}
